/*
 *   File : order-filter.js
 *   Author : https://evoqins.com
 *   Description : Order Filter modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';

//custom component
import { PrimaryButton, SecondaryButton, TextButton } from '../Buttons';


const FILTER_OPTIONS_PAYMENT_STATUS = [
    {
        id: null,
        label: "All"
    },
    {
        id: 1,
        label: "Pending"
    },
    {
        id: 2,
        label: "Success"
    },
    {
        id: 3,
        label: "Failed"
    }
];

const FILTER_OPTIONS_ORDER_TYPE = [
    {
        id: null,
        label: "All"
    },
    {
        id: 1,
        label: "Purchase"
    },
    {
        id: 3,
        label: "Redemption"
    },
    {
        id: 4,
        label: "Switch"
    }
];

const DEFAULT_FILTER_ORDER_FOR = {
    id: -1,
    label: "My orders"
};

const DEFAULT_FILTER_PAYMENT_STATUS = {
    id: null,
    label: "All"
};

const DEFAULT_FILTER_ORDER_TYPE = {
    id: null,
    label: "All"
};

const OrderFilterModal = (props) => {

    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(props.selectedPaymentStatus);
    const [selectedOrderType, setSelectedOrderType] = useState(props.selectedOrderType);
    const [filterOrdersFor, setFilterOrdersFor] = useState(props.selectedFilterOrdersFor);

    useEffect(() => {
        setSelectedOrderType(props.selectedOrderType);
    }, [props.selectedOrderType]);

    useEffect(() => {
        setSelectedPaymentStatus(props.selectedPaymentStatus);
    }, [props.selectedPaymentStatus]);

    useEffect(() => {
        setFilterOrdersFor(props.selectedFilterOrdersFor);
    }, [props.selectedFilterOrdersFor]);


    const _handleFilterTypeSelect = (selected_filter, type) => {
        if (type === 1) {
            setFilterOrdersFor(selected_filter);
        } else if (type === 2) {
            setSelectedOrderType(selected_filter);
        } else if (type === 3) {
            setSelectedPaymentStatus(selected_filter);
        }
    };

    // //Handle submit filter
    const _handleApplyFilter = () => {
        props.handleApplyFilter(filterOrdersFor, selectedOrderType, selectedPaymentStatus)
    };

    const _handleClearAll = () => {
        setFilterOrdersFor(DEFAULT_FILTER_ORDER_FOR);
        setSelectedOrderType(DEFAULT_FILTER_ORDER_TYPE);
        setSelectedPaymentStatus(DEFAULT_FILTER_PAYMENT_STATUS);
    };

    return (
        <div className="position-absolute  w-374px right-8px top-50px z-index-9 p-3 e-border-radius-24 e-bg-white e-box-shadow-filter-modal e-order-filter-modal">

            <div className="d-flex justify-content-between pb-3">
                <h6 className='e-text-charleston-green e-alt-font-poppins e-font-14-res e-font-18 e-font-weight-600 line-height-32px mb-0'>
                    Filter by
                </h6>
                <TextButton type={2}
                    icon={false}
                    name="Clear all"
                    fontSize={"e-font-12-res e-font-14"}
                    className="border-0 text-decoration-hover-underline"
                    onClick={_handleClearAll} />
            </div>



            <p className='e-text-charleston-green e-alt-font-poppins e-font-12-res e-font-14 e-font-weight-500 line-height-24px letter-spacing-5 margin-12px-bottom'>
                Orders for
            </p>
            <div className='d-flex flex-wrap gap-2 mb-3'>
                {
                    (props.filterOptionsOrdersFor || []).map((item, key) => (
                        <span className={`${filterOrdersFor.id == item.id ? "e-bg-lavender-web e-text-egyptian-blue" : "e-bg-concrete-gray e-text-dark-liver "} e-font-weight-400 cursor-pointer  e-alt-font-poppins e-font-14  line-height-24px e-border-radius-24  px-3 py-2`}
                            key={key}
                            onClick={() => _handleFilterTypeSelect(item, 1)}>
                            {item.label}
                        </span>
                    ))
                }

            </div>

            <p className='e-text-charleston-green e-alt-font-poppins e-font-12-res e-font-14 e-font-weight-500 line-height-24px letter-spacing-5 margin-12px-bottom'>
                Order type
            </p>
            <div className='d-flex flex-wrap gap-2 mb-3'>
                {
                    (FILTER_OPTIONS_ORDER_TYPE || []).map((item, key) => (
                        <span className={`${selectedOrderType.id == item.id ? "e-bg-lavender-web e-text-egyptian-blue" : "e-bg-concrete-gray e-text-dark-liver "} e-font-weight-400 cursor-pointer  e-alt-font-poppins e-font-14  line-height-24px e-border-radius-24  px-3 py-2`}
                            key={key}
                            onClick={() => _handleFilterTypeSelect(item, 2)}>
                            {item.label}
                        </span>
                    ))
                }
            </div>

            <p className='e-text-charleston-green e-alt-font-poppins e-font-12-res e-font-14 e-font-weight-500 line-height-24px letter-spacing-5 margin-12px-bottom'>
                Payment status
            </p>
            <div className='d-flex flex-wrap gap-2 mb-3'>
                {
                    (FILTER_OPTIONS_PAYMENT_STATUS || []).map((item, key) => (
                        <span className={`${selectedPaymentStatus.id == item.id ? "e-bg-lavender-web e-text-egyptian-blue" : "e-bg-concrete-gray e-text-dark-liver "} e-font-weight-400 cursor-pointer  e-alt-font-poppins e-font-14  line-height-24px e-border-radius-24  px-3 py-2`}
                            key={key}
                            onClick={() => _handleFilterTypeSelect(item, 3)}>
                            {item.label}
                        </span>
                    ))
                }
            </div>

            <div className="d-flex align-items-center gap-2 mt-4">
                <SecondaryButton name="Cancel"
                    className="w-100 py-sm-3 py-2 e-bg-lotion e-font-16 e-text-charleston-green e-border-bright-gray "
                    onPress={props.handleCancelFilter}
                    borderRadius="e-border-radius-10" />
                <PrimaryButton name="Apply"
                    className="w-100 e-font-16 py-2 py-sm-3 e-border-radius-10"
                    onPress={_handleApplyFilter} />
            </div>
        </div>
    );
};

export default OrderFilterModal;